import State from "../../Player/states/states.js";
import { EnemyStateConfig } from "../../GameConfig/EnemyConfig.js";
import { randomInt } from "../enemy.js";

export default class Attack extends State {
  constructor(enemy) {
    super(EnemyStateConfig.ATTACK);

    this.enemy = enemy;
  }

  enter() {
    const randomWeaponIndex = randomInt(0, this.enemy.weapons.length - 1);
    this.enemy.projectiles.push(
      new this.enemy.weapons[randomWeaponIndex](
        this.enemy.x + this.enemy.spriteWidth / 2,
        this.enemy.y + this.enemy.spriteHeight / 2,
      ),
    );
  }

  update() {
    this.enemy.setState(EnemyStateConfig.FLY);
  }
}
